<script setup lang="ts">
const delay = `${Math.random() / 2}s`;
defineProps<{
  showHeader: boolean;
}>();
</script>

<template>
  <h3 v-if="showHeader" class="__header __animateContent"></h3>
  <div class="__employee-row">
    <div class="__user-picture __animateContent"></div>
    <div class="__left-info">
      <p class="__display-name __animateContent"></p>
      <p class="__scheduled-time __animateContent"></p>
    </div>
    <div class="__coming-up __animateContent">
      <p class="__coming-up__label">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
    </div>
  </div>
</template>

<style scoped>
@keyframes contentAnimation {
  0% {
    opacity: 0.1;
  }
  50% {
    opacity: 0.01;
  }
  100% {
    opacity: 0.1;
  }
}

.__header {
  height: 30px;
  width: 230px;
  margin-bottom: 16px;
  background-color: var(--co-background-secondary);
}

.__user-picture {
  height: 30px;
  width: 30px;
  border-radius: 50% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--co-background-secondary);
}

@keyframes opacityAnimation {
  0% {
    background-color: var(--co-background-primary);
  }
  50% {
    background-color: var(--co-background-secondary);
  }
  100% {
    background-color: var(--co-background-primary);
  }
}

.__employee-row {
  padding: 20px 15px;
  border: 1px solid var(--co-lines-border-solid);
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  gap: 16px;
  align-items: center;
}

.__animateContent {
  opacity: 0.1;
  border-radius: 5px;
  background-color: var(--co-text-secondary);
  animation-duration: 1s;
  animation-delay: v-bind(delay);
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: contentAnimation;
  animation-timing-function: linear;
}

.__display-name {
  text-transform: capitalize;
  font-size: 17px;
  width: 210px;
  height: 18px;
}

.__scheduled-time {
  width: 80px;
  height: 14px;
  margin-top: 4px;
}

.__coming-up {
  margin-left: auto;
}

.__coming-up__label {
  width: 80px;
  height: 14px;
}
</style>
